export const MODE = {
  CREATE: 'create',
  DUPLICATE: 'duplicate',
};

export const DEADLINE_MODE = {
  DISABLED: 'disabled',
  MANDATORY: 'mandatory',
};